import { Instagram, Facebook, Youtube } from "lucide-react";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" aria-hidden="true" {...props}>
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.5c-1.3.1-2.5-.3-3.6-1v6.4c0 3.3-2.4 5.7-5.6 5.7C7.5 20.5 5 18 5 15c0-2.9 2.3-5.2 5.2-5.2.3 0 .6 0 .9.1v2.7c-.3-.1-.6-.2-.9-.2-1.4 0-2.5 1.1-2.5 2.6 0 1.4 1.1 2.6 2.6 2.6 1.5 0 2.6-1.2 2.6-2.9V3h3.6z" />
  </svg>
);

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17" aria-hidden="true" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
  </svg>
);

const NETWORKS = [
  { id: "instagram", label: "Instagram", Icon: Instagram, env: "REACT_APP_INSTAGRAM_URL", fallback: "https://instagram.com" },
  { id: "facebook", label: "Facebook", Icon: Facebook, env: "REACT_APP_FACEBOOK_URL", fallback: "https://facebook.com" },
  { id: "tiktok", label: "TikTok", Icon: TikTok, env: "REACT_APP_TIKTOK_URL", fallback: "https://tiktok.com" },
  { id: "youtube", label: "YouTube", Icon: Youtube, env: "REACT_APP_YOUTUBE_URL", fallback: "https://youtube.com" },
  { id: "x", label: "X", Icon: XIcon, env: "REACT_APP_X_URL", fallback: "https://x.com" },
];

export const SocialIcons = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="social-icons">
    {NETWORKS.map(({ id, label, Icon, env, fallback }) => (
      <a
        key={id}
        href={process.env[env] || fallback}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        title={label}
        data-testid={`social-${id}`}
        className="w-9 h-9 rounded-full border border-[#D4AF37]/40 bg-[#111] text-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] hover:text-black transition-colors"
      >
        <Icon />
      </a>
    ))}
  </div>
);
